import { useState } from 'react';
import { useAuth } from '../lib/auth';
import { ErrorNote, TextField } from '../components/ui';

export function LoginPage() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(email, password);
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <form className="login__card" onSubmit={submit}>
        <div className="login__brand">
          <img src="/logo.svg" alt="" />
          <b>Lindsay Curling Club</b>
          <span>Club Office</span>
        </div>

        {error ? <div style={{ marginBottom: '1rem' }}><ErrorNote error={error} /></div> : null}

        <fieldset disabled={busy}>
          <TextField label="Email" type="email" value={email} onChange={setEmail} required />
          <TextField label="Password" type="password" value={password} onChange={setPassword} required />
          <button className="btn btn--accent btn--block" type="submit" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </fieldset>

        <p className="small muted" style={{ marginTop: '1.15rem', textAlign: 'center' }}>
          Members can also use the companion app.<br />
          Trouble signing in? Call the club on 705-324-3851.
        </p>
      </form>
    </div>
  );
}
